import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Link } from 'react-router';
import { sendQuestionEmail } from 'redux/modules/helpcenter';
import renderIcon from 'helpers/renderIcon';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'react-redux';
import { LoadingOverlayWrapper } from 'components';
const classNames = require('classnames');
const { connect } = require('react-redux');

require('./style.scss');

const stateToProps = (state: IStore) => ({
	helpCenter: state.helpCenter,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	sendQuestionEmail: (body) => dispatch(sendQuestionEmail(body)),
});

export const ContactUsForm = connect(
	stateToProps,
	dispatchToProps,
)(
	translate(c.DEFAULT_TRANSLATION_NAMESPACE)((props) => {
		const { t, helpCenter, topic } = props;
		const [name, setName] = React.useState('');
		const [surname, setSurname] = React.useState('');
		const [email, setEmail] = React.useState('');
		const [phoneNumber, setPhoneNumber] = React.useState('');
		const [message, setMessage] = React.useState('');
		const [agree, setAgree] = React.useState(false);

		return (
			<form
				className="contact-form"
				onSubmit={(e) => {
					e.preventDefault();
					if (agree) {
						props
							.sendQuestionEmail({
								name,
								surname,
								email,
								phoneNumber,
								message,
								topic: topic || 'contact us form',
							})
							.then((error) => {
								if ((!error && !helpCenter.status) || helpCenter.status == 200) {
									setName('');
									setSurname('');
									setEmail('');
									setPhoneNumber('');
									setMessage('');
								}
							});
					}
				}}
			>
				<div className="container">
					<div className="row d-xlg-none">
						<div className="col-12 col-xlg-4 offset-xlg-1">
							<h2 className="contact-form__big-title">{t('CreateShopPresentation_Contact_Title')}</h2>
							<p className="contact-form__big-description">{t('CreateShopPresentation_Contact_Description')}</p>
						</div>
					</div>
					<div className="row">
						<div className="col-12 col-xlg-5 offset-xlg-1">
							<LoadingOverlayWrapper active={helpCenter?.isFetching} spinner={true} text={t('BSPortal_Common_Loading')}>
								<div className="row">
									<div className="col-12 col-sm-6">
										<label className="contact-form__text-label" id="name_label">
											{t('CreateShopPresentation_Contact_Name')}
										</label>
										<input
											className="contact-form__text-input"
											type="text"
											name="name"
											value={name}
											onChange={(e) => setName(e.target.value)}
											aria-labelledby="name_label"
											autoComplete="given-name"
										/>
									</div>
									<div className="col-12 col-sm-6">
										<label className="contact-form__text-label" id="surname_label">
											{t('CreateShopPresentation_Contact_Surname')}
										</label>
										<input
											className="contact-form__text-input"
											type="text"
											name="surname"
											value={surname}
											onChange={(e) => setSurname(e.target.value)}
											aria-labelledby="surname_label"
											autoComplete="family-name"
										/>
									</div>
								</div>
								<div className="row">
									<div className="col-12 col-sm-6">
										<label className="contact-form__text-label" id="email_label">
											{t('CreateShopPresentation_Contact_Email')}
										</label>
										<input
											className="contact-form__text-input"
											type="text"
											name="email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											aria-labelledby="email_label"
											autoComplete="email"
										/>
									</div>
									<div className="col-12 col-sm-6">
										<label className="contact-form__text-label" id="phone_number">
											{t('CreateShopPresentation_Contact_PhoneNumber')}
										</label>
										<input
											className="contact-form__text-input"
											type="text"
											name="phone"
											value={phoneNumber}
											onChange={(e) => setPhoneNumber(e.target.value)}
											aria-labelledby="phone_number"
											autoComplete="tel"
										/>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<label className="contact-form__text-label" id="message_label">
											{t('CreateShopPresentation_Contact_Message')}
										</label>
										<textarea
											className="contact-form__text-input"
											name="message"
											value={message}
											onChange={(e) => setMessage(e.target.value)}
											aria-labelledby="message_label"
										/>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<label
											className={classNames('contact-form__checkbox-label', {
												'contact-form__checkbox-label--unchecked': !agree,
											})}
											id="privacy_label"
											onClick={() => setAgree(!agree)}
										>
											{renderIcon(agree ? 'checked' : 'unchecked')}
											<span>
												{t('CreateShopPresentation_Contact_PrivacyNote_0')}{' '}
												<Link to="/termsofuse/en">{t('CreateShopPresentation_Contact_PrivacyNote_1')}</Link>{' '}
												{t('CreateShopPresentation_Contact_PrivacyNote_2')}{' '}
												<Link to="/privacypolicy/en">{t('CreateShopPresentation_Contact_PrivacyNote_3')}</Link>
											</span>
										</label>
										<input
											className={classNames('contact-form__submit', {
												'contact-form__submit--disabled': !agree || helpCenter?.isFetching,
											})}
											type="submit"
											value={t('BSPortal_Common_Send')}
										/>
									</div>
								</div>
							</LoadingOverlayWrapper>
						</div>
						<div className="col-12 col-xlg-4 offset-xlg-1 d-none d-xlg-block">
							<h2 className="contact-form__big-title">{t('CreateShopPresentation_Contact_Title')}</h2>
							<p className="contact-form__big-description">{t('CreateShopPresentation_Contact_Description')}</p>
						</div>
					</div>
				</div>
			</form>
		);
	}),
);
